import { HttpClient } from '@angular/common/http';
import { UserInvitation } from '@account-users/account/models';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { InviteAdminError } from '../../models';
import { BaseCommand } from '../Command';
import { InviteCommand, InviteCommandResponse } from './invite-command';

@Injectable()
export class InviteCommandService extends BaseCommand<
  InviteCommand,
  InviteCommandResponse
> {
  private readonly inviteAdminErrorMsg =
    'Could not invite a user to this account';

  constructor(
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {
    super();
  }

  public execute(command: InviteCommand): Observable<InviteCommandResponse> {
    const { accountId, ...invitation }: UserInvitation = command;
    return this.httpClient
      .post<InviteCommandResponse>(
        `${this.apiBaseUrl}accounts/${accountId}/users`,
        invitation,
      )
      .pipe(
        catchError((err) =>
          throwError(
            new InviteAdminError({
              error: err,
              message: this.inviteAdminErrorMsg,
            }),
          ),
        ),
      );
  }
}
